export function parse(data, field = null) {
  const json = JSON.parse(data);
  if (field !== null) {
    return json["/" + field][0];
  }

  const result = {};
  for (const key in json) {
    if (key === "/images") {
      result[key.substring(1)] = json[key];
    } else {
      result[key.substring(1)] = json[key][0];
    }
  }
  return result;
}
